export default __webpack_public_path__ + "static/media/school2.98d4097d.webp";